import React from 'react'

import { useAppSelector } from 'redux/Hook'
import FilterPill from './FilterPill'

const FilterPills = () => {
  const { selectedQuestions } = useAppSelector((state) => state.signUpQuestions)
  return (
    <>
      {selectedQuestions.map(({ question, value, type, selected }, index) => (
        <FilterPill
          key={`${value}_${index}`}
          question={question}
          value={value}
          type={type}
          selected={selected}
          index={index}
        />
      ))}
    </>
  )
}

export default FilterPills
